import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpCompletePage',
  setup(__props) {

const m = defineMessages({
  emailSentTitle: '登録用メールが送信されました',
  emailSentMessage1:
    '入力されたメールアドレスにアカウント登録完了用のメールを送信しました。',
  emailSentMessage2:
    'メールボックスをご確認いただき、24時間以内にメール本文のリンクにアクセスしてアカウント登録完了をお願いいたします。',
});

return { __sfc: true,m }
}

})